import React from "react";
import { TailSpin } from "react-loader-spinner";

export default function Loader() {
  return (
    <TailSpin
      visible={true}
      height="100"
      width="90"
      color="#4fa94d"
      ariaLabel="tail-spin-loading"
      radius="1"
      wrapperStyle={{}}
      wrapperClass="custom-spinner"
    />
  );
}
